<template>
  <v-list-item
      @click="clicked">
    <v-list-item-avatar>
      <v-icon color="primary">
        {{ folderIcon }}
      </v-icon>
    </v-list-item-avatar>

    <v-list-item-content>
      <v-list-item-title :class="item.is_default ? 'font-weight-bold primary--text' : ''">{{ item.name }}
      </v-list-item-title>
      <v-list-item-title class="subtitle-2 font-weight-thin">{{ this.folderDisplayName }}</v-list-item-title>
    </v-list-item-content>

    <v-list-item-content>
      <v-list-item-title :class="item.is_default ? 'font-weight-bold primary--text' : ''">
        Sortierindex {{ item.order_index }}
      </v-list-item-title>
    </v-list-item-content>

    <v-list-item-content class="text-right">
      <v-flex>
        <v-tooltip bottom v-if="item.demo_video_url && item.demo_video_url !== ''">
          <template #activator="{ on }">
            <v-icon v-on="on" color="warning" class="me-4">mdi-video</v-icon>
          </template>
          <span>Hilfsvideo hinterlegt</span>
        </v-tooltip>

        <v-tooltip bottom v-if="item.demo_pdf_url && item.demo_pdf_url !== ''">
          <template #activator="{ on }">
            <v-icon v-on="on" color="warning">mdi-file-pdf-box</v-icon>
          </template>
          <span>Hilfs-PDF hinterlegt</span>
        </v-tooltip>
      </v-flex>
    </v-list-item-content>

    <v-menu bottom left v-if="item">
      <template class="ps-4" v-slot:activator="{ on, attrs }">
        <v-btn
            class="ms-8"
            icon
            v-bind="attrs"
            v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <!--File creation only for Free Folders-->
        <v-list-item
            v-if="canAddFiles"
            @click.stop="$emit('file', item)">
          <v-list-item-title>Datei hinzufügen</v-list-item-title>
        </v-list-item>
        <!--Folder creation only for Ueber and Free Folders-->
        <v-list-item
            v-if="canAddFolders"
            @click.stop="$emit('add', {'folder': item, 'isEdit': false})">
          <v-list-item-title>Ordner hinzufügen</v-list-item-title>
        </v-list-item>
        <!--Edit for ALL Folders-->
        <v-list-item
            v-if="!item.is_default"
            @click.stop="$emit('edit', {'folder': item, 'isEdit': true})">
          <v-list-item-title>Ordner editieren</v-list-item-title>
        </v-list-item>
        <!--Replace only for Formular, Leistungs and Documentation Folders-->
        <v-list-item
            v-if="canReplaceFile"
            @click.stop="$emit('replace', item)">
          <v-list-item-title>Vorlagendatei ersetzen</v-list-item-title>
        </v-list-item>
        <!--Delete for ALL Folders-->
        <v-list-item
            v-if="!item.is_default"
            @click.stop="$emit('delete', item)">
          <v-list-item-title>Ordner löschen</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-list-item>
</template>
<script>
import {FolderTypeApi} from "@/ts/enums/FolderTypeApi";
import {FolderType} from "@/ts/enums/FolderType";

export default {
  name: 'folder-list-tile',
  data() {
    return {
      folderDisplayName: ""
    }
  },
  props: {
    item: {}
  },
  watch: {
    item() {
      this.getFolderDisplayName()
    }
  },
  mounted() {
    this.getFolderDisplayName()
  },
  computed: {
    canAddFiles() {
      let result = false
      switch (this.item.folder_type) {
        case FolderTypeApi.FREE:
        case FolderTypeApi.IMAGE:
          result = true;
          break;
      }
      return result
    },
    canAddFolders() {
      let result = false
      switch (this.item.folder_type) {
        case FolderTypeApi.FREE:
        case FolderTypeApi.PARENT:
          result = true;
          break;
      }
      return result
    },
    canReplaceFile() {
      let result = false
      switch (this.item.folder_type) {
        case FolderTypeApi.DOCUMENTATION:
        case FolderTypeApi.FORMULAR:
        case FolderTypeApi.LEISTUNG:
        case FolderTypeApi.LEISTUNG_OHNE_PREISE:
          result = true;
          break;
      }
      return result
    },
    folderIcon() {
      let result = 'mdi-folder' // == Freier Ordner
      switch (this.item.folder_type) {
        case FolderTypeApi.PARENT:
          result = 'mdi-folder-network'
          break;
        case FolderTypeApi.FORMULAR:
          result = 'mdi-folder-text'
          break;
        case FolderTypeApi.LEISTUNG:
        case FolderTypeApi.LEISTUNG_OHNE_PREISE:
          result = 'mdi-folder-star'
          break;
        case FolderTypeApi.IMAGE:
          result = 'mdi-folder-image'
          break;
        case FolderTypeApi.DOCUMENTATION:
          result = 'mdi-folder-key'
          break;
      }
      return result
    }
  },
  methods: {
    clicked() {
      this.$emit('click', this.item)
    },
    getFolderDisplayName() {
      switch (this.item.folder_type) {
        case FolderTypeApi.PARENT:
          this.folderDisplayName = FolderType.PARENT;
          break;
        case FolderTypeApi.FORMULAR:
          this.folderDisplayName = FolderType.FORMULAR;
          break;
        case FolderTypeApi.LEISTUNG:
          this.folderDisplayName = FolderType.LEISTUNG;
          break;
        case FolderTypeApi.LEISTUNG_OHNE_PREISE:
          this.folderDisplayName = FolderType.LEISTUNG_OHNE_PREISE;
          break;
        case FolderTypeApi.DOCUMENTATION:
          this.folderDisplayName = FolderType.DOCUMENTATION;
          break;
        case FolderTypeApi.IMAGE:
          this.folderDisplayName = FolderType.IMAGE;
          break;
        case FolderTypeApi.FREE:
          this.folderDisplayName = FolderType.FREE;
          break;
      }
    }
  }
}
</script>
